module.exports = __webpack_public_path__ + "img/aggregate-follow.0710e325.jpg";